/**
 * splits text into alternating prose / code-fence segments, handling
 * fences of any length (3+) by matching opening and closing runs of equal length
 * via a backreference.
 */
export function splitCodeFences(text: string): string[] {
  const result: string[] = []
  const fenceRe = /(^|\n)(`{3,})[^\n]*\n[\s\S]*?(?:\n\2\s*(?=\n|$)|$)/g
  let lastIndex = 0

  for (const match of text.matchAll(fenceRe)) {
    const fenceStart = match.index + (match[1]?.length ?? 0) // skip the leading \n captured in group 1
    if (fenceStart > lastIndex) result.push(text.slice(lastIndex, fenceStart))
    result.push(text.slice(fenceStart, match.index + match[0].length))
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) result.push(text.slice(lastIndex))
  return result.filter(s => s !== '')
}

export function isCodeFenceSegment(segment: string): boolean {
  return /^`{3,}[^\n]*\n/.test(segment)
}

export function extractCodeContent(fenceSegment: string): string {
  const fenceMatch = /^`{3,}/.exec(fenceSegment)
  if (!fenceMatch) return ''
  const fenceLen = fenceMatch[0].length
  const firstNewline = fenceSegment.indexOf('\n')
  if (firstNewline === -1) return ''
  return fenceSegment.slice(firstNewline + 1).replace(new RegExp(`\n\`{${fenceLen}}\\s*$`), '')
}
